import { WEB_SOCKET_BASE_URL } from '../constants/common';
import toast from "react-hot-toast";

let socket = null;
let reconnectAttempts = 0;
let reconnectTimer = null;
let dispatchRef = null;

const MAX_RECONNECT_ATTEMPTS = 10;
const RECONNECT_INTERVAL = 5000;

const WebSocketService = {
  connect: (dispatch) => {
    dispatchRef = dispatch; // keep reference for reuse

    const token = localStorage.getItem("token");
    if (!token) {
      console.warn("⚠️ No token available — skipping WebSocket connection.");
      return;
    }

    // If already open or connecting, skip
    if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) {
      console.log("🔄 WebSocket already active, skipping new connection.");
      return;
    }

    const wsUrl = `${WEB_SOCKET_BASE_URL || "ws://localhost:8000/ws/notifications/"}?token=${token}`;
    console.log("🌐 Connecting WebSocket:", wsUrl);

    socket = new WebSocket(wsUrl);

    socket.onopen = () => {
      console.log("✅ WebSocket connected successfully.");
      reconnectAttempts = 0;
      if (reconnectTimer) {
        clearTimeout(reconnectTimer);
        reconnectTimer = null;
      }
    };

    socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        const message = data.message;
        const type = data.type;
        if (type === 'success'){
            console.log("📩 Message from socket:", data);
            toast.success(message|| "New notification received!");
            setTimeout(() => {
              window.location.reload();
            }, 2000); // Wait 2 seconds to show toast
        }else{
            console.log("📩 Message from socket:", data);
            toast.error(message|| "New notification received!");
            setTimeout(() => {
              window.location.reload();
            }, 2000); // Wait 2 seconds to show toast
        }
      } catch (error) {
        console.error("❌ Failed to parse WebSocket message:", error);
      }
    };

    socket.onclose = (event) => {
      console.warn("⚠️ WebSocket closed:", event.code, event.reason);
      socket = null;

      // Try to reconnect if user is still logged in
      if (localStorage.getItem("token")) {
        WebSocketService.scheduleReconnect();
      }
    };

    socket.onerror = (error) => {
      console.error("⚠️ WebSocket error:", error);
      socket.close();
    };
  },

  scheduleReconnect: () => {
    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      console.error("🚫 Max reconnect attempts reached. Stopping retries.");
      return;
    }

    reconnectAttempts++;
    const delay = Math.min(RECONNECT_INTERVAL * reconnectAttempts, 30000); // exponential backoff
    console.log(`⏳ Reconnecting WebSocket in ${delay / 1000}s (attempt ${reconnectAttempts})`);

    reconnectTimer = setTimeout(() => {
      WebSocketService.connect(dispatchRef);
    }, delay);
  },

  disconnect: () => {
    if (socket) {
      console.log("🔌 Closing WebSocket connection...");
      socket.close();
      socket = null;
    }
    if (reconnectTimer) {
      clearTimeout(reconnectTimer);
      reconnectTimer = null;
    }
  },

  send: (message) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify(message));
    } else {
      console.warn("⚠️ Cannot send message, socket not open:", message);
    }
  },

  isConnected: () => socket && socket.readyState === WebSocket.OPEN,
};

export default WebSocketService;